import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import PropTypes from "prop-types";
import { QUESTION_TYPES } from "./CustomerSatisfactionSurvey";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	answerChoice: {
		marginLeft: 20,
		marginBottom: 8,
		display: "flex",
		alignItems: "center",
	},
	answerChoiceLabel: {
		marginLeft: 16,
	},
	answerContainer: {
		marginTop: 16,
		[breakpoints.mobileOnly]: {
			marginTop: 12,
		},
	},
	inputContainer: {
		paddingLeft: 20,
		[breakpoints.mobileOnly]: {
			paddingRight: 16,
		},
	},
	question: {
		marginTop: 26,
		display: "flex",
		[breakpoints.mobileOnly]: {
			marginTop: 18,
		},
	},
	questionNumber: {
		marginRight: 12,
	},
	radio: {
		marginTop: 2,
	},
	text: {
		fontFamily: "freight-sans-pro",
		fontSize: 15,
		lineHeight: 1.33,
		color: colors.black7,
	},
	textInput: {
		border: `4px solid ${colors.gray5}`,
		width: "100%",
		height: 60,
		fontSize: 16,
		boxSizing: "border-box",
		paddingLeft: 12,
		paddingRight: 6,
		marginBottom: 18,
		[breakpoints.mobileOnly]: {
			marginBottom: 2,
			marginTop: -6,
		},
		":focus": {
			outline: "none",
		},
	},
});

export default class SurveyQuestion extends PureComponent {
	static propTypes = {
		question: PropTypes.shape({
			id: PropTypes.number.isRequired,
			prompt: PropTypes.string.isRequired,
			questionType: PropTypes.string.isRequired,
			choices: PropTypes.arrayOf(PropTypes.string),
		}).isRequired,
		answerQuestion: PropTypes.func.isRequired,
	};

	_answerQuestion = e => {
		this.props.answerQuestion(this.props.question, e.target.value);
	};

	_renderAnswer = () => {
		if (this.props.question.questionType === QUESTION_TYPES.MULT_CHOICE) {
			return (
				<div>
					{this.props.question.choices.map((choice, i) => {
						return (
							<div
								className={css(styles.answerChoice)}
								// eslint-disable-next-line
								key={`${this.props.question.id}-${i}`}
							>
								<input
									name={this.props.question.id}
									id={`input-${this.props.question.id}-${i}`}
									type="radio"
									value={i}
									className={css(styles.radio)}
									onChange={this._answerQuestion}
								/>
								<label
									className={css([styles.answerChoiceLabel, styles.text])}
									htmlFor={`input-${this.props.question.id}-${i}`}
								>
									{choice}
								</label>
							</div>
						);
					})}
				</div>
			);
		} else if (this.props.question.questionType === QUESTION_TYPES.FREE_RESPONSE_SHORT) {
			return (
				<div className={css(styles.inputContainer)}>
					<input className={css(styles.textInput)} onChange={this._answerQuestion} />
				</div>
			);
		} else {
			return null;
		}
	};

	render() {
		return (
			<div>
				<div className={css([styles.text, styles.question])}>
					<div className={css(styles.questionNumber)}>
						{this.props.question.id}
						{"."}
					</div>
					<div>{this.props.question.prompt}</div>
				</div>
				<div className={css(styles.answerContainer)}>{this._renderAnswer()}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/SurveyQuestion.js